import * as React from "react";
import { Dialog, DialogContent, DialogTitle, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface IPdfViewerDialogProps {
    title: string;
    link: string;
    onClose: () => void;
}
export const PdfViewerDialog = (props: IPdfViewerDialogProps) => {
    return (
        <Dialog maxWidth={"xl"} onClose={props.onClose} open={true}>
            <DialogTitle sx={{ m: 0, p: 2, backgroundColor: "#3A3A3A", color: "white" }}>
                <Typography variant="h6">{props.title}</Typography>
                <IconButton aria-label="close" onClick={props.onClose}
                            sx={{
                                position: "absolute",
                                right: 8,
                                top: 8,
                                color: "white",
                            }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent className={"dialog__content"}>
                <div>
                    <iframe src={props.link} width={window.innerWidth * 0.8} height={window.innerHeight}/>
                </div>
            </DialogContent>
        </Dialog>
    );
};
